import axiosInstance from '../../../config/axiosConfig';
import { urlAmenazasVulnerabilidades } from '../../../config/apiURL';
import { extractArray, extractDataObject } from '../../utils/responseHelpers';

// Obtener todas las amenazas y vulnerabilidades
export async function getAmenazasVulnerabilidades() {
  try {
    const response = await axiosInstance.get(urlAmenazasVulnerabilidades);
    return extractArray(response);
  } catch (error) {
    console.error('Error fetching amenazas vulnerabilidades:', error);
    throw error;
  }
}

export async function getAmenazasVulnerabilidadesTotal() {
  try {
    const response = await axiosInstance.get(`${urlAmenazasVulnerabilidades}/total`);
    return extractArray(response);
  } catch (error) {
    console.error('Error fetching amenazas vulnerabilidades:', error);
    throw error;
  }
}

export async function getAmenazasVulnerabilidadesAgrupacion(id) {
  try {
    const response = await axiosInstance.get(`${urlAmenazasVulnerabilidades}/agrupacion/${id}`);
    return extractArray(response);
  } catch (error) {
    console.error('Error fetching amenazas vulnerabilidades:', error);
    throw error;
  }
}

export async function getFechaAmenazaVulnerabilidad(vulnerabilidadCodigo) {
  try {
    const response = await axiosInstance.get(`${urlAmenazasVulnerabilidades}/fecha/${vulnerabilidadCodigo}`);
    return extractArray(response);
  } catch (error) {
    console.error(`Error fetching fecha for vulnerabilidad ${vulnerabilidadCodigo}:`, error);
    throw error;
  }
}

export async function getAmenazasVulnerabilidadesRangos() {
  try {
    const response = await axiosInstance.get(`${urlAmenazasVulnerabilidades}/rangos`);
    return extractArray(response);
  } catch (error) {
    console.error('Error fetching amenazas vulnerabilidades:', error);
    throw error;
  }
}

export async function getTablaAmenazasVulnerabilidades(currentId, currentDate) {
  try {
    const formattedDate = encodeURIComponent(currentDate);
    const response = await axiosInstance.get(`${urlAmenazasVulnerabilidades}/tabla/${currentId}/${formattedDate}`);
    return extractArray(response);
  } catch (error) {
    console.error(`Error fetching tabla for id ${currentId} and date ${currentDate}:`, error);
    throw error;
  }
}

export async function getProcesoAmenazaVulnerabilidad(id, fecha) {
  try {
    const response = await axiosInstance.get(`${urlAmenazasVulnerabilidades}/proceso/${id}/${fecha}`);
    return extractArray(response);
  } catch (error) {
    console.error(`Error fetching proceso for id ${id} and date ${fecha}:`, error);
    throw error;
  }
}

export async function getAmenazaVulnerabilidadPorIds(ame_codigo, vul_codigo) {
  try {
    const response = await axiosInstance.get(`${urlAmenazasVulnerabilidades}/${ame_codigo}/${vul_codigo}`);
    return extractDataObject(response);
  } catch (error) {
    console.error(`Error fetching amenaza vulnerabilidad:`, error);
    throw error;
  }
}

export async function getAmenazaVulnerabilidadPorVulCodigo(vul_codigo) {
  try {
    const response = await axiosInstance.get(`${urlAmenazasVulnerabilidades}/vulnerabilidad/${vul_codigo}`);
    return extractArray(response);
  } catch (error) {
    console.error(`Error fetching amenaza vulnerabilidad por vul_codigo ${vul_codigo}:`, error);
    throw error;
  }
}

export async function createAmenazaVulnerabilidad(data) {
  try {
    const response = await axiosInstance.post(urlAmenazasVulnerabilidades, data);
    return extractDataObject(response);
  } catch (error) {
    console.error('Error creating amenaza vulnerabilidad:', error);
    throw error;
  }
}

export async function updateAmenazaVulnerabilidad(ame_codigo, vul_codigo, data) {
  try {
    const response = await axiosInstance.put(`${urlAmenazasVulnerabilidades}/${ame_codigo}/${vul_codigo}`, data);
    return extractDataObject(response);
  } catch (error) {
    console.error('Error updating amenaza vulnerabilidad:', error);
    throw error;
  }
}

export async function deleteAmenazaVulnerabilidad(ame_codigo, vul_codigo) {
  try {
    const response = await axiosInstance.delete(`${urlAmenazasVulnerabilidades}/${ame_codigo}/${vul_codigo}`);
    return extractDataObject(response);
  } catch (error) {
    console.error('Error deleting amenaza vulnerabilidad:', error);
    throw error;
  }
}